import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
// import vuetify from './plugins/vuetify'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'
import device from 'vue-device-detector-js'
import VueApexCharts from 'vue-apexcharts'
import './plugins/axios';
import './plugins/validators';
import './plugins/toastification';
import './plugins/async-computed';
import './plugins/router-sync';
import './plugins/mask';
import './plugins/moment';
import './plugins/sweet-alert';
import './plugins/utils';
import './plugins/shortkey';
import money from 'v-money';
import mixins from '@/mixins';

Vue.use(device);
Vue.use(money);

Vue.config.productionTip = process.env.NODE_ENV === 'production';

// Importar os Mixins
mixins.forEach((mixin) => {
  Vue.mixin(mixin);
});

//Customizar tema
Vue.use(Vuetify)
const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#1374B9', // Substitua essa cor pela desejada
      },
      dark: {
        primary: '#1374B9', // Substitua essa cor pela desejada no tema escuro
      },
    },
  },
})

Vue.component('apexchart', VueApexCharts)
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
